import { defineMessages } from 'react-intl';

export default defineMessages({
  sign_up_token_not_found: {
    id: 'Signup.toastr.apiErrors.invalidToken',
    defaultMessage: 'Cette invitation n\'est plus valable',
    description: 'Invitation expirée',
  },
  used_sign_up_token: {
    id: 'Signup.toastr.apiErrors.usedSignupToken',
    defaultMessage: 'Cette invitation a déjà été utilisée',
    description: 'Invitation déjà utilisée',
  },
  conflict: {
    id: 'Signup.toastr.apiErrors.conflict',
    defaultMessage: 'Cette invitation a déjà été utilisée',
    description: 'Invitation expirée',
  },
  default: {
    id: 'Signup.toastr.apiErrors.default',
    defaultMessage: 'Une erreur est survenue, merci de réessayer',
    description: 'Signaler un étudiant - defaut',
  },
  toastrEmailValidation: {
    id: 'Signup.toastr.emailValidation',
    defaultMessage: 'Pour finaliser votre inscription, cliquez sur le lien qui vous a été envoyé par email.',
  },
});
